import { voucherCodes } from 'constants/vouchers';
import { sum } from 'utils/calculator';

export const voucherAdditionalDetailsKey = 'manually_generated_voucher';

export const voucherAdditionalDetails = {
  [voucherCodes.SFV]: `${voucherAdditionalDetailsKey}-s3_failed`,
  [voucherCodes.VGV]: `${voucherAdditionalDetailsKey}-voyager_group`
};

export const vouchersInAdditionalDetails = (booking) => {
  if (!booking?.additionalDetails) {
    return [];
  }

  return booking.additionalDetails.filter((item) => item.key?.includes(voucherAdditionalDetailsKey));
};

export const vouchersAliasList = (vouchersAdditionalDetails) => vouchersAdditionalDetails.map((voucher) => voucher.value) || [];

export const sumAllVoucherValues = (voucherDetails) => sum(voucherDetails.map((voucher) => voucher?.value));
